<script setup lang="ts">
const { data: testimonials } = useFetch<Array<{ id: string, name: string, description: string, quote: string, avatar: string | null }>>('/api/testimonials', {
  key: 'testimonials',
  default: () => [],
})
</script>

<template>
  <UPageColumns class="public-content">
    <UPageCard
      v-for="(testimonial, index) in testimonials"
      :key="index"
      variant="subtle"
      :description="testimonial.quote"
      class="public-card"
      :ui="{ description: 'text-[var(--ink-900)] before:content-[open-quote] after:content-[close-quote]' }"
    >
      <template #footer>
        <UUser
          :name="testimonial.name"
          :description="testimonial.description"
          :avatar="testimonial.avatar ? { src: `https://api.ambulancepresent.be/assets/${testimonial.avatar}?width=96&height=96&fit=cover&quality=75&format=webp` } : undefined"
          size="xl"
          :ui="{ name: 'font-semibold text-[var(--ink-900)]', description: 'text-[var(--ink-700)]' }"
        />
      </template>
    </UPageCard>
  </UPageColumns>
</template>
